import { __extends, __awaiter, __generator, __assign, __decorate, __metadata } from 'tslib';
import { CssDevice, languageQuery, isMobileQuery, configQuery, getFeatureEnabled, getFeatureValueV2, RoutablePage, scroll, interpolate, formatCurrency, ImageFormat, getImagePath, ImageType, cdnService, MagicConfigMixin } from '@gig/magic-common';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { Feature, LANGUAGE_UPDATED, BREAKPOINT_DEVICE_UPDATED, BREAKPOINT_DEVICE_QUERY, BALANCE_FIAT_CURRENCY_QUERY, USER_PROFILE_DATA } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { compactFormatter, roundDownFormatter } from '../../utils/helpers.js';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';

var DEFAULT_COIN_SHOP_IMAGE_WIDTH = 80;
var SweepstakesBuy = /** @class */ (function (_super) {
    __extends(SweepstakesBuy, _super);
    function SweepstakesBuy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showSsn = false;
        _this.showScan = false;
        _this.isDepositAllowed = true;
        _this.isDepositAllowedByFeatureFlag = true;
        _this.promos = [];
        _this.selectedPromo = null;
        _this.isDiamondCoinsEnabled = false;
        _this.compactView = false;
        _this.isMobile = false;
        _this.depositData = null;
        _this.configCoinShopImageWidth = DEFAULT_COIN_SHOP_IMAGE_WIDTH;
        _this.isImageBackgroundEnabled = false;
        _this.showVerificationProgress = false;
        _this.fiatCurrency = Currency.USD;
        return _this;
    }
    SweepstakesBuy.prototype.created = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c, error_1;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.updateDepositStatus()];
                    case 1:
                        _d.sent();
                        return [4 /*yield*/, this.updateSsnStatus()];
                    case 2:
                        _d.sent();
                        this.userProfileSubscription = magic.events.userProfileUpdated(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.showVerificationProgress = false;
                                        return [4 /*yield*/, this.updateDepositStatus()];
                                    case 1:
                                        _a.sent();
                                        return [4 /*yield*/, this.updateSsnStatus()];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }).unsub;
                        _b = this;
                        return [4 /*yield*/, configQuery('coinShopImageWidth')];
                    case 3:
                        _b.configCoinShopImageWidth =
                            (_a = (_d.sent())) !== null && _a !== void 0 ? _a : DEFAULT_COIN_SHOP_IMAGE_WIDTH;
                        _c = this;
                        return [4 /*yield*/, window.queryBus.query(BALANCE_FIAT_CURRENCY_QUERY)];
                    case 4:
                        _c.fiatCurrency = _d.sent();
                        this.subscription = window.eventBus.subscribe([LANGUAGE_UPDATED, BREAKPOINT_DEVICE_UPDATED], function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, language, mobile, device, _b, slug, promo;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, Promise.all([
                                            languageQuery(),
                                            isMobileQuery(),
                                        ])];
                                    case 1:
                                        _a = _c.sent(), language = _a[0], mobile = _a[1];
                                        return [4 /*yield*/, window.queryBus.query(BREAKPOINT_DEVICE_QUERY)];
                                    case 2:
                                        device = _c.sent();
                                        this.compactView =
                                            device === CssDevice.MOBILE || device === CssDevice.PHABLET;
                                        this.isMobile = mobile;
                                        _b = this;
                                        return [4 /*yield*/, this.fetchPromotions(language, mobile)];
                                    case 3:
                                        _b.promos = _c.sent();
                                        slug = this.promoSlug;
                                        promo = this.promos.find(function (promo) { return promo.slug === slug; });
                                        if (slug && promo) {
                                            this.selectPromo(promo);
                                        }
                                        else {
                                            this.clearPromo();
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); }, { replay: true, distinct: true });
                        this.updateFeatureFlags();
                        _d.label = 5;
                    case 5:
                        _d.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.triggerKYCVerifications(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_ENTERING_COIN_SHOP)];
                    case 6:
                        _d.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _d.sent();
                        // Error already handled in triggerKYCVerifications
                        console.error('Error in triggerKYCVerifications', error_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBuy.prototype.updateFeatureFlags = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, getFeatureEnabled('sweepstakes-diamond-coins')];
                    case 1:
                        _a.isDiamondCoinsEnabled = _c.sent();
                        _b = this;
                        return [4 /*yield*/, getFeatureEnabled('coin-shop-background')];
                    case 2:
                        _b.isImageBackgroundEnabled = _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBuy.prototype.destroyed = function () {
        var _a;
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        if (this.userProfileSubscription) {
            this.userProfileSubscription();
        }
    };
    SweepstakesBuy.prototype.updateDepositStatus = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var user, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getProfile()];
                    case 1:
                        user = _c.sent();
                        this.isDepositAllowed = (_a = user === null || user === void 0 ? void 0 : user.compliance.isDepositAllowed) !== null && _a !== void 0 ? _a : true;
                        _b = this;
                        return [4 /*yield*/, this.getIsDepositAllowedByFeatureFlag()];
                    case 2:
                        _b.isDepositAllowedByFeatureFlag =
                            _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBuy.prototype.updateSsnStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var feature, ssnRequired, profile, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        feature = Feature.SSN_REQUIRED_BEFORE_PURCHASE;
                        return [4 /*yield*/, getFeatureEnabled(feature)];
                    case 1:
                        ssnRequired = _b.sent();
                        return [4 /*yield*/, this.getProfile()];
                    case 2:
                        profile = _b.sent();
                        if (!(!this.isDepositAllowed && ssnRequired && !profile.user.taxId)) return [3 /*break*/, 4];
                        this.showSsn = true;
                        _a = this;
                        return [4 /*yield*/, getFeatureValueV2(feature, '')];
                    case 3:
                        _a.showScan = (_b.sent()).includes('scan-verification');
                        return [3 /*break*/, 5];
                    case 4:
                        this.showSsn = false;
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBuy.prototype.onSsnError = function () {
        notificationService.show(this.$t('file-upload.scan.failed'), {
            style: NotificationStyle.ERROR,
            uniqueID: 'sweepx-purchase-scan-error',
        });
    };
    SweepstakesBuy.prototype.onSsnUpdate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateDepositStatus()];
                    case 1:
                        _a.sent();
                        if (this.isDepositAllowed) {
                            notificationService.show(this.$t('sweepstakes-ssn.purchase.success'), {
                                style: NotificationStyle.SUCCESS,
                                uniqueID: 'sweepx-purchase-ssn-success',
                            });
                        }
                        else {
                            notificationService.show(this.$t('sweepstakes-ssn.purchase.error'), {
                                style: NotificationStyle.ERROR,
                                uniqueID: 'sweepx-purchase-ssn-error',
                            });
                        }
                        this.showSsn = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBuy.prototype.onVerification = function () {
        this.routeTo({ route: RoutablePage.VERIFICATION });
    };
    SweepstakesBuy.prototype.selectPromo = function (promo) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.triggerKYCVerifications(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_SELECTING_COIN_SHOP_PURCHASE_METHOD)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        // Error already handled in triggerKYCVerifications
                        console.error('Error in triggerKYCVerifications', error_2);
                        return [2 /*return*/];
                    case 3:
                        // Check if deposit is allowed after KYC verification
                        if (!this.isDepositAllowed) {
                            console.error('Deposit not allowed');
                            return [2 /*return*/];
                        }
                        this.selectedPromo = promo;
                        this.routeTo({
                            route: RoutablePage.SWEEPSTAKES_SHOP,
                            params: { promoSlug: this.selectedPromo.slug },
                        });
                        if (this.isMobile) {
                            scroll.scrollToTop();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBuy.prototype.clearPromo = function () {
        this.selectedPromo = null;
        this.routeTo({ route: RoutablePage.SWEEPSTAKES_SHOP });
    };
    SweepstakesBuy.prototype.getShopInfo = function (promo) {
        // @ts-ignore
        return promo.sweepStakesShop;
    };
    SweepstakesBuy.prototype.getGoldCoins = function (promo) {
        var coins = this.getShopInfo(promo).itemsToGrant.goldCoins;
        return coins ? +coins.amount : 0;
    };
    SweepstakesBuy.prototype.getSweepCoins = function (promo) {
        var coins = this.getShopInfo(promo).itemsToGrant.sweepCoins;
        return coins ? +coins.amount : 0;
    };
    SweepstakesBuy.prototype.getDiamondCoins = function (promo) {
        var coins = this.getShopInfo(promo).itemsToGrant.diamondCoins;
        var amount = coins ? +coins.amount : 0;
        if (amount === 0 || !this.isDiamondCoinsEnabled) {
            return '';
        }
        var formattedAmount = amount >= 1000
            ? compactFormatter.format(amount)
            : roundDownFormatter.format(amount);
        return "+" + formattedAmount;
    };
    SweepstakesBuy.prototype.getGoldCoinsFormatted = function (promo) {
        return interpolate(this.$t('sweepstakes.goldcoins-short'), {
            amount: this.getGoldCoins(promo).toLocaleString(),
        });
    };
    SweepstakesBuy.prototype.getSweepCoinsFormatted = function (promo) {
        return interpolate(this.$t('sweepstakes.sweepcoins-short'), {
            amount: this.getSweepCoins(promo).toLocaleString(),
        });
    };
    SweepstakesBuy.prototype.getBuyLabel = function (promo) {
        var amount = this.getPrice(promo);
        return interpolate(this.$t('sweepstakes-buy.button'), {
            amount: formatCurrency(amount, this.fiatCurrency),
        });
    };
    SweepstakesBuy.prototype.getPromoLabel = function (promo) {
        var amount = this.getPrice(promo);
        return interpolate(this.$t('sweepstakes-buy.promo-label'), {
            amount: formatCurrency(amount, this.fiatCurrency),
        });
    };
    SweepstakesBuy.prototype.getAvifSrcset = function (promo) {
        return this.getImageSrcset(promo, ImageFormat.AVIF);
    };
    SweepstakesBuy.prototype.getWebpSrcset = function (promo) {
        return this.getImageSrcset(promo, ImageFormat.WEBP);
    };
    SweepstakesBuy.prototype.getPromoSrc = function (promo) {
        return this.getImage(promo, ImageFormat.WEBP);
    };
    SweepstakesBuy.prototype.getPrice = function (promo) {
        return +this.getShopInfo(promo).price.amount;
    };
    SweepstakesBuy.prototype.onDepositResult = function (data) {
        console.error('onDepositResult', data);
        this.depositData = data.detail[0];
    };
    Object.defineProperty(SweepstakesBuy.prototype, "successDepositMessage", {
        get: function () {
            var _a;
            var promo = this.selectedPromo;
            return interpolate(this.$t('sweepstakes-buy.success-deposit'), {
                goldCoins: this.getGoldCoins(promo).toLocaleString(),
                sweepCoins: this.getSweepCoins(promo).toLocaleString(),
                transactionID: (_a = this.depositData) === null || _a === void 0 ? void 0 : _a.transactionID,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesBuy.prototype, "successDepositPendingMessage", {
        get: function () {
            var promo = this.selectedPromo;
            return interpolate(this.$t('sweepstakes-buy.success-pending-deposit'), {
                goldCoins: this.getGoldCoins(promo).toLocaleString(),
                sweepCoins: this.getSweepCoins(promo).toLocaleString(),
            });
        },
        enumerable: false,
        configurable: true
    });
    SweepstakesBuy.prototype.fetchPromotions = function (language, mobile) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, magic.methods.promotions.filter('sweepstakes shop', language, mobile)];
                    case 1: return [2 /*return*/, (_a.sent())
                            .filter(function (promo) {
                            var _a, _b;
                            var item = _this.getShopInfo(promo);
                            return (((_a = item === null || item === void 0 ? void 0 : item.itemsToGrant) === null || _a === void 0 ? void 0 : _a.goldCoins) ||
                                ((_b = item === null || item === void 0 ? void 0 : item.itemsToGrant) === null || _b === void 0 ? void 0 : _b.sweepCoins));
                        })
                            .map(function (promo) { return (__assign(__assign({}, promo), { hidden: promo.types.includes('hidden') })); })];
                }
            });
        });
    };
    SweepstakesBuy.prototype.getImageSrcset = function (promo, format) {
        if (this.isImageBackgroundEnabled && !this.selectedPromo) {
            return this.getBackground(promo, format) + ", " + this.getBackground(promo, format, true) + " 2x";
        }
        else {
            return this.getImage(promo, format) + ", " + this.getImage(promo, format, true) + " 2x";
        }
    };
    SweepstakesBuy.prototype.getImage = function (promo, format, retina) {
        if (retina === void 0) { retina = false; }
        if (!promo.image) {
            return null;
        }
        var promotionImage = getImagePath(ImageType.PROMO_IMAGES, promo.image);
        return cdnService.getImageUrl(promotionImage, {
            width: DEFAULT_COIN_SHOP_IMAGE_WIDTH,
            quality: 100,
            retina: retina,
            format: format,
        });
    };
    SweepstakesBuy.prototype.getBackground = function (promo, format, retina) {
        var _a;
        if (retina === void 0) { retina = false; }
        var imageParams = {
            width: (_a = this.configCoinShopImageWidth) !== null && _a !== void 0 ? _a : DEFAULT_COIN_SHOP_IMAGE_WIDTH,
            quality: 100,
            retina: retina,
            format: format,
        };
        if (!promo.background) {
            return null;
        }
        if (this.isMobile && promo.mobileBackground) {
            return cdnService.getPromotionMobileBackgroundUrl(promo.mobileBackground, imageParams);
        }
        return cdnService.getPromotionBackgroundUrl(promo.background, imageParams);
    };
    SweepstakesBuy.prototype.getProfile = function () {
        return window.queryBus.query(USER_PROFILE_DATA);
    };
    SweepstakesBuy.prototype.getIsDepositAllowedByFeatureFlag = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, triggerKYCVerificationsBeforeSelectingCoinShopPurchaseMethod;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_SELECTING_COIN_SHOP_PURCHASE_METHOD)];
                    case 2:
                        triggerKYCVerificationsBeforeSelectingCoinShopPurchaseMethod = _a.sent();
                        if (triggerKYCVerificationsBeforeSelectingCoinShopPurchaseMethod &&
                            (user === null || user === void 0 ? void 0 : user.compliance.idVerificationStatus) === AmlStatus.NOT_SET) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, this.isDepositAllowed];
                }
            });
        });
    };
    SweepstakesBuy.prototype.triggerKYCAndWaitForProfileUpdate = function (intent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        // Set up the event listener first
                        var unsubscribe = magic.events.userProfileUpdated(function () {
                            unsubscribe();
                            resolve();
                        }).unsub;
                        // Trigger the KYC verification request
                        magic.methods.users
                            .triggerKYCVerificationsRequest({ intent: intent })
                            .then(function (res) {
                            if (!res.sent) {
                                unsubscribe();
                                reject(new Error('KYC verification request not sent'));
                            }
                        })
                            .catch(function (error) {
                            unsubscribe();
                            reject(error);
                        });
                    })];
            });
        });
    };
    SweepstakesBuy.prototype.triggerKYCVerifications = function (feature) {
        return __awaiter(this, void 0, void 0, function () {
            var user, triggerKYCVerifications, triggerKycVerificationsValue, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(feature)];
                    case 2:
                        triggerKYCVerifications = _a.sent();
                        return [4 /*yield*/, getFeatureValueV2(feature)];
                    case 3:
                        triggerKycVerificationsValue = _a.sent();
                        if (!(triggerKYCVerifications &&
                            triggerKycVerificationsValue &&
                            (user === null || user === void 0 ? void 0 : user.compliance.idVerificationStatus) === AmlStatus.NOT_SET)) return [3 /*break*/, 5];
                        this.startKYCVerificationProgress();
                        // Wait for both the request AND the profile update event
                        return [4 /*yield*/, this.triggerKYCAndWaitForProfileUpdate(triggerKycVerificationsValue)];
                    case 4:
                        // Wait for both the request AND the profile update event
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.showVerificationProgress = false;
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_3 = _a.sent();
                        this.triggerKYCVerificationsError();
                        throw error_3; // Re-throw to prevent caller from continuing
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBuy.prototype.startKYCVerificationProgress = function () {
        this.isDepositAllowed = false;
        this.isDepositAllowedByFeatureFlag = false;
        this.showVerificationProgress = true;
    };
    SweepstakesBuy.prototype.triggerKYCVerificationsError = function () {
        notificationService.show(this.$t('sweepstakes.verification-fails'), {
            style: NotificationStyle.ERROR,
            uniqueID: 'kyc-verifications-error',
        });
        this.routeTo({ route: RoutablePage.HOME });
        this.showVerificationProgress = false;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], SweepstakesBuy.prototype, "promoSlug", void 0);
    SweepstakesBuy = __decorate([
        Component({
            name: 'sweepstakes-buy',
        })
    ], SweepstakesBuy);
    return SweepstakesBuy;
}(Mixins(MagicConfigMixin)));

export default SweepstakesBuy;
